import { convertDatesToISO, getHeaders } from "@/config/aux";
import { DeviceSample } from "../models/deviceSample";
import { MeasurementsStateType } from "./state";
import axios from "axios";

export interface MeasurementsActionsType {
  getMeasurements(): Promise<void>;
  getMeasurementsByDeviceId(deviceId: string): Promise<DeviceSample[]>;
  //getMeasurementById(id: string): Promise<void>
  postMeasurement(deviceSample: DeviceSample): Promise<void>;
  putMeasurement(deviceSample: DeviceSample): Promise<void>;
  deleteMeasurement(id: string): Promise<void>;
  clearError(): void;
}

export const MeasurementsActions = {
  async getMeasurements(this: MeasurementsStateType) {
    try {
      this.loading = true;
      this.error = null;
      this.deviceSamples = [];

      const query = `${process.env.VUE_APP_URL_BASE}/device-samples`;
      await axios.get(query, { headers: getHeaders() }).then((response) => {
        if (response.status === 200) {
          response.data.forEach((measurementData: any) => {
            this.deviceSamples.push(new DeviceSample(measurementData));
          });
        }
      });
    } catch (error: any) {
      console.error("Error getting DeviceSamples", error);
      this.error = error.message || "Error al cargar mediciones";
    } finally {
      this.loading = false;
    }
  },

  async getMeasurementsByDeviceId(
    this: MeasurementsStateType,
    deviceId: string
  ): Promise<DeviceSample[]> {
    try {
      this.loading = true;
      this.error = null;

      // console.log(
      //   "[DeviceSamples] getMeasurementsByDeviceId - deviceId:",
      //   deviceId
      // );
      const query = `${process.env.VUE_APP_URL_BASE}/device/${deviceId}/device-samples`;
      // console.log("[DeviceSamples] Query URL:", query);
      const response = await axios.get(query, { headers: getHeaders() });
      // console.log("[DeviceSamples] Response status:", response.status);
      // console.log(
      //   "[DeviceSamples] Response data count:",
      //   response.data?.length || 0
      // );
      // console.log("[DeviceSamples] Response data:", response.data);

      if (response.status === 200 && response.data && Array.isArray(response.data)) {
        const deviceMeasurements = response.data
          .map((measurementData: any) => new DeviceSample(measurementData))
          .sort(
            (a: DeviceSample, b: DeviceSample) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );

        return deviceMeasurements;
      } else {
        // console.log("[DeviceSamples] No data or invalid response");
      }

      return [];
    } catch (error: any) {
      console.error("Error getting DeviceSamples by deviceId", error);
      this.error =
        error.message || "Error al cargar mediciones del dispositivo";
      return [];
    } finally {
      this.loading = false;
    }
  },

  //   async getMeasurementById(this: MeasurementsStateType, id: string) {
  //     try {
  //       this.loading = true
  //       this.error = null
  //       this.deviceSample = null

  //       const query = `${process.env.VUE_APP_URL_BASE}/api/deviceSamples/${id}`
  //       await axios.get(query, { headers: getHeaders() }).then(response => {
  //         if (response.status === 200) {
  //           this.deviceSample = new DeviceSample(response.data)
  //         }
  //       })
  //     } catch (error: any) {
  //       console.error('Error getting DeviceSample by id', error)
  //       this.error = error.message || 'Error al cargar medición'
  //     } finally {
  //       this.loading = false
  //     }
  //   },

  async postMeasurement(
    this: MeasurementsStateType,
    deviceSample: DeviceSample
  ) {
    try {
      this.loading = true;
      this.error = null;

      const query = `${process.env.VUE_APP_URL_BASE}/device-samples`;
      const data = convertDatesToISO(deviceSample.toPlainObject());

      await axios
        .post(query, data, { headers: getHeaders() })
        .then((response) => {
          if (response.status === 201) {
            this.deviceSamples.push(new DeviceSample(response.data));
          }
        });
    } catch (error: any) {
      console.error("Error posting DeviceSample", error);
      this.error = error.message || "Error al crear medición";
    } finally {
      this.loading = false;
    }
  },

  async putMeasurement(
    this: MeasurementsStateType,
    deviceSample: DeviceSample
  ) {
    try {
      this.loading = true;
      this.error = null;
      console.log("Updating deviceSample:", deviceSample);
      const query = `${process.env.VUE_APP_URL_BASE}/device-samples`;
      const data = convertDatesToISO(deviceSample.toPlainObject());
      console.log("Data to be sent:", data);
      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            const index = this.deviceSamples.findIndex(
              (m) => m.id === deviceSample.id
            );
            if (index !== -1) {
              this.deviceSamples[index] = new DeviceSample(response.data);
            }
          }
        });
    } catch (error: any) {
      console.error("Error updating DeviceSample", error);
      this.error = error.message || "Error al actualizar medición";
    } finally {
      this.loading = false;
    }
  },

  async deleteMeasurement(this: MeasurementsStateType, id: string) {
    try {
      this.loading = true;
      this.error = null;

      const query = `${process.env.VUE_APP_URL_BASE}/device-samples/${id}`;
      await axios.delete(query, { headers: getHeaders() }).then((response) => {
        if (response.status === 200) {
          this.deviceSamples = this.deviceSamples.filter((m) => m.id !== id);
        }
      });
    } catch (error: any) {
      console.error("Error deleting DeviceSample", error);
      this.error = error.message || "Error al eliminar medición";
    } finally {
      this.loading = false;
    }
  },

  clearError(this: MeasurementsStateType) {
    this.error = null;
  },
};
